import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/nejcm/docz-theme-extended/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Hint, InlineCode } from '@nejcm/docz-theme-extended';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "header"
    }}>{`Header`}</h1>
    <p>{`Improved and redesigned header now allows making the header fixed and adding a logo image.`}</p>
    <h2 {...{
      "id": "config"
    }}>{`Config`}</h2>
    <h3 {...{
      "id": "fixed-header"
    }}>{`Fixed header`}</h3>
    <p>{`Inside `}<inlineCode parentName="p">{`doczrc.js`}</inlineCode>{` file there is a `}<inlineCode parentName="p">{`themeConfig.header.fixed`}</inlineCode>{` option:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//doczrc.js
export default {
  themeConfig: {
    header: {
      fixed: true,
    },
  },
};
`}</code></pre>
    <h4 {...{
      "id": "options"
    }}>{`Options`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fixed`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Specify if the header should be fixed at the top.`}</td>
        </tr>
      </tbody>
    </table>
    <hr />
    <h3 {...{
      "id": "logo"
    }}>{`Logo`}</h3>
    <p>{`Inside `}<inlineCode parentName="p">{`doczrc.js`}</inlineCode>{` file there is a `}<inlineCode parentName="p">{`themeConfig.logo`}</inlineCode>{` option with a possibility to define logos for light and dark theme.`}</p>
    <Hint type="warning" mdxType="Hint">
  The image has to be placed inside the <InlineCode mdxType="InlineCode">public</InlineCode> folder
  or the provided option has to be an url address.
    </Hint>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//doczrc.js
export default {
  themeConfig: {
    logo: {
      src: '/public/logo.svg',
      width: 50,
    },
  },
};
`}</code></pre>
    <p>{`Example with an url:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//doczrc.js
export default {
  themeConfig: {
    logo: {
      src: 'https://www.my-website.com/logo.svg',
      width: 50,
    },
  },
};
`}</code></pre>
    <p>{`Example with a light and dark theme logo option:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//doczrc.js
export default {
  themeConfig: {
    logo: {
      src: {
        light: '/public/logo.svg',
        dark: 'https://www.my-website.com/logo-dark.svg',
      },
      width: 50,
    },
  },
};
`}</code></pre>
    <h4 {...{
      "id": "options-1"
    }}>{`Options`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`src`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`—`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Specify the image source as an path or url.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`width`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`75px`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Specify the image width.`}</td>
        </tr>
      </tbody>
    </table>
    <hr />
    <h3 {...{
      "id": "icons"
    }}>{`Icons`}</h3>
    <p>{`Inside `}<inlineCode parentName="p">{`doczrc.js`}</inlineCode>{` file there is a `}<inlineCode parentName="p">{`themeConfig.header.icons`}</inlineCode>{` option:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//doczrc.js
export default {
  themeConfig: {
    header: {
      icons: 'minimal',
    },
  },
};
`}</code></pre>
    <h4 {...{
      "id": "options-2"
    }}>{`Options`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`icons`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`'minimal'`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`'default'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`default`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Specify the header icons style.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      